(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });


  const isMobileScreen = () => {
  return window.matchMedia('(min-width: 769px)').matches;
};

let navListenersAttached = false;

const setupNavEventListeners = () => {
  const navItems = document.querySelectorAll('.child-nav li');

  if (isMobileScreen()) {
    if (!navListenersAttached) {
      navItems.forEach(function(listItem) {
        const navMenu = listItem.querySelector('.custom__nav--item details');

        if (navMenu) {
          listItem.addEventListener('mouseenter', openNavMenu);
          listItem.addEventListener('mouseleave', closeNavMenu);
        }
      });
      navListenersAttached = true
    }
  } else {
    if (navListenersAttached) {
      navItems.forEach(function(listItem) {
        const navMenu = listItem.querySelector('.custom__nav--item details');
        if (navMenu) {
          listItem.removeEventListener('mouseenter', openNavMenu);
          listItem.removeEventListener('mouseleave', closeNavMenu);
          // Ensure nav menu is closed
          navMenu.classList.remove('is-open');
          navMenu.removeAttribute('open');

        }
      });
      navListenersAttached = false;
    }
  }
};

const openNavMenu = function() {
  const navMenu = this.querySelector('.custom__nav--item details');
  if (navMenu) {
    navMenu.classList.add('is-open');
    navMenu.setAttribute('open', '');
  }

  console.log(navMenu)
};

const closeNavMenu = function() {
  const navMenu = this.querySelector('.custom__nav--item details');
  if (navMenu) {
    navMenu.classList.remove('is-open');
    navMenu.removeAttribute('open');
  }
};

setupNavEventListeners();

window.addEventListener('resize', function() {
  setupNavEventListeners();
});
  

  } catch(e) { console.error(e); }
})();
})();
